import { Icon } from "@iconify/react";

export default function Unlocked() {
    return (
        <div className="p-1 bg-default-200 rounded-lg flex gap-2">  
            <Icon className="text-primary-500 text-sm" icon="solar:lock-unlocked-bold" />
        </div>
    );
}
